import Vue from 'vue'
Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // 检查点击目标是否是指令元素或其子元素
      if (!(el === event.target || el.contains(event.target))) {
        // 如果绑定的值是函数，则调用它
        if (typeof binding.value === 'function') {
          binding.value(event);
        }
        if (binding.modifiers.prevent) {
          event.preventDefault();
        }
        if (binding.modifiers.stop) {
          event.stopPropagation();
        }
      }
    };
    
    document.addEventListener('click', el.clickOutsideEvent, true);
  },
  unbind(el) {
    document.removeEventListener('click', el.clickOutsideEvent, true);
  }
})